export const BLOB_RECEIVED = 'BLOBS/RECEIVED';
export const BLOB_REQUESTED = 'BLOBS/REQUESTED';

export const CUSTOM_LOGO_REQUESTED = 'BLOBS/CUSTOM_LOGO_REQUESTED';
export const CUSTOM_LOGO_RECEIVED = 'BLOBS/CUSTOM_LOGO_RECEIVED';
